<header class="header text-center">
        <img src="assets/images/logo.png" alt="logo">
</header>

<section>
    <div  class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-sm-10 text-center">
                <div class="boxConainer">
                  <h1>
                        Toll Free No.
                  </h1>  
                  <p>
                        1800 212 1212
                  </p>

                  <h1>
                        Email ID
                  </h1>
                  <p>
                        care@edelweisslife.in
                  </p>
                </div>
                
            </div>
        </div>
    </div>
</section>